/**
 * @type {Object} constants used to modify the state.
 */
export default {
  login: 'USER/LOGIN',
  verify: 'USER/VERIFY',
  closeCustomer: 'USER/CLOSE_CUSTOMER',
  logout: 'USER/LOGOUT',
};
